// @ts-nocheck
import KitchenSidebar, { KitchenMobileNav } from "./KitchenSidebar";
import DashboardV2 from "./DashboardV2";
import "./KitchenShell.css";

export default function KitchenDashboardShell({
  activeModule = null,
  bedrijfsnaam,
  logoUrl,
  weatherPlace,
  dashboardProps,
  onNavigate,
  onOpenWhiteboard,
  onOpenHelp,
  language,
}) {
  const nav = (moduleId, subView = null) => onNavigate?.(moduleId, subView);

  return (
    <div className="kc-shell">
      <KitchenSidebar
        activeModule={activeModule}
        onNavigate={(moduleId) => nav(moduleId, moduleId === "mep" ? "lijst" : null)}
        bedrijfsnaam={bedrijfsnaam}
        logoUrl={logoUrl}
        weatherPlace={weatherPlace}
      />
      <DashboardV2
        {...dashboardProps}
        onNavigate={nav}
        onOpenWhiteboard={onOpenWhiteboard}
        onOpenHelp={onOpenHelp}
        language={language}
      />
      <KitchenMobileNav
        activeModule={activeModule}
        onNavigate={(moduleId) => nav(moduleId, moduleId === "mep" ? "lijst" : null)}
      />
    </div>
  );
}
